// import livro from '../../imagens/livro.png'

export const ultimosLancamentos = [
    {nome: 'Liderança em Design', src: 'https://cdn.shopify.com/s/files/1/0155/7645/products/LiderancaemDesign_ebook_large.jpg?v=1631656080', id: 1},
    {nome: 'Cangaceiro JavaScript', src: 'https://caelum-online-public.s3.amazonaws.com/2628-js/JavaScript.png', id: 2},
    {nome: 'Apache Kafka e Spring Boot', src: 'https://cdn.shopify.com/s/files/1/0155/7645/products/Apache-Kafka-Digital__ebook_large.jpg?v=1643659546', id: 3}
]